import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { powerModuleInfo } from "../../../fetch/fetchApi";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class HistoryStubInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.historyStubInfo;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.init();
  }

  init() {
    console.log(this.props.sn);
    this.formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // '请输入设备编号',,
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: this.internationalization.title1, // '设备编号:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              icon: "search",
              text: this.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        sn: this.props.sn,
        flag: "0",
      },
      autoLoadGrid: true, // 设置为false不触发加载grid
      context: this,
      tableKey: "hisStubListTable",
    };
    this.setState({
      tableConfig: {
        noPagination: true,
        tableKey: "hisStubListTable",
        tableColumns: [
          {
            name: this.internationalization.title1, // '设备编号',
            key: "stubId",
            colType: "textCol",
            align: "center",
            render: (value, row) => {
              if (value !== this.internationalization.wz1) {
                const time = row.modifyTime.split(" ")[0];
                return (
                  <div>
                    <a
                      onClick={() => {
                        this.openTab(
                          {
                            keyId: `moduleInfo`,
                            stubId: row.stubId,
                            createTime: time,
                            subjectSerial: row.sn,
                          },
                          {
                            key: "moduleInfo",
                            titleText: this.internationalization.wz2, // '模块信息',
                          },
                        );
                      }}>
                      {value}
                    </a>
                  </div>
                );
              } else {
                return value;
              }
            },
          },
          {
            name: this.internationalization.title2, // '运行时长',,
            colType: "textCol",
            align: "center",
            render: (value, row) => {
              const timeInfo = this.handleSecord(row.runtime);
              const msg = <div>{timeInfo}</div>;

              return msg;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          flag: "0",
          sn: this.props.sn,
        },
        dataApi: powerModuleInfo,
        autoRefresh: true, // 设置为true 直接加载grid数据
      },
    });
  }

  // 秒转换
  handleSecord(value) {
    const day = Math.floor(value / (24 * 3600)); // Math.floor()向下取整
    const hour = Math.floor((value - day * 24 * 3600) / 3600);
    const minute = Math.floor((value - day * 24 * 3600 - hour * 3600) / 60);
    const second = value - day * 24 * 3600 - hour * 3600 - minute * 60;
    if (day > 0) {
      return (
        day +
        this.internationalization.dw +
        hour +
        this.internationalization.hour +
        minute +
        this.internationalization.minute +
        second +
        this.internationalization.second
      );
    } else if (hour > 0) {
      return (
        hour +
        this.internationalization.hour +
        minute +
        this.internationalization.minute +
        second +
        this.internationalization.second
      );
    } else if (minute > 0) {
      return minute + this.internationalization.minute + second + this.internationalization.second;
    } else {
      return second + this.internationalization.second;
    }
  }

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} />
        </div>
        <div className="page-panel overScroll">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(HistoryStubInfo);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/module/historyStubInfo.js